import { operationsApi } from '../api/services/operationsApi';

function pickExportFileUrl(response = {}) {
  return (
    response.fileUrl ||
    response.file_url ||
    response.downloadUrl ||
    response.download_url ||
    response.urls?.orig ||
    response.url ||
    response.link ||
    ''
  );
}

function pickExportFileName(response = {}) {
  return (
    response.fileName ||
    response.file_name ||
    response.name ||
    response.filename ||
    response.keys?.orig?.split('/').at(-1) ||
    ''
  );
}

export function normalizeExportFile(response = {}) {
  const url = pickExportFileUrl(response);

  return {
    url,
    fileName: pickExportFileName(response) || 'sandrapay-transactions.csv',
  };
}

export async function requestHistoryExport() {
  const response = await operationsApi.getCsvFile({
    limit: 25,
    fileType: 'csv',
  });

  return normalizeExportFile(response);
}
